import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cae472f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "welcome-images",
  role: "presentation",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "img" }
const _hoisted_3 = { class: "welcome-content" }
const _hoisted_4 = { class: "welcome-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "welcome-bottom-half" }
const _hoisted_7 = { class: "welcome-text" }
const _hoisted_8 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OptimizedImage = _resolveComponent("OptimizedImage")!
  const _component_Initiator = _resolveComponent("Initiator")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["welcome", { started: _ctx.init }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.home?.page.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "welcome-image floating",
          key: 'image-' + index
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_OptimizedImage, {
              image: image,
              width: 400,
              lazy: false,
              sqip: false
            }, null, 8, ["image"])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.home?.page.quotes, (quote) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: quote }, [
              _createTextVNode(_toDisplayString(quote) + " ", 1),
              _hoisted_5
            ], 64))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "confirm-btn outline-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args)))
        }, "Bezoek het monument")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.home?.page.introText), 1)
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.showInitiator)
            ? (_openBlock(), _createBlock(_component_Initiator, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      class: "close-btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args)))
    }, [
      _createVNode(_component_Icon, { name: "close" })
    ])
  ], 2))
}